import { render, staticRenderFns } from "./FaqListView.vue?vue&type=template&id=06bfa2d6"
import script from "./FaqListView.vue?vue&type=script&lang=ts"
export * from "./FaqListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports